const config = {
  API_URL:
    process.env.REACT_APP_API_URL || 'https://mirakel-api.enghssport.com/api',
  MEDIA_URL:
    process.env.REACT_APP_API_MEDIA_URL || 'https://mirakel-api.enghssport.com',
};

export default config;
